import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const LeadPaymentTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [roleData, setRoleData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchFormData(
        "list-lead-payment-bank",
        formData,
        "POST"
      );

      if (result) {
        const user = result.data || [];
        setRoleData(user);
      }
    } catch (error) {
      topTost({ title: "Something went wrong", icon: "error" });
    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    try {
      const formData = new FormData();
      formData.append("id", Id); // Send ID in form data
      formData.append("userId", userId);
      formData.append("moduleId", M_id);
      const result = await fetchFormData(
        `change-status-lead-payment-bank`,
        formData,
        "POST"
      );

      if (result && result.code === 200) {
       await fetchAllData();
        if (result?.status === 1) {
          topTost({
            title: "Status updated successfully: Active",
            icon: "success",
          });
        } else {
          topTost({
            title: "Status updated successfully: Deactive",
            icon: "success",
          });
        }
      } else {
        topTost({ title: "Failed to update status", icon: "error" });
      }
    } catch (error) {
      topTost({ title: "Something went wrong", icon: "error" });
    } finally {
      Swal.close();
    }
  };
  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <FiEdit3
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/payout/edit-inquiry-payment/${id}?id=${M_id}`)
                      }
                    />
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "bank_master_name",
      header: () => "Bank Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_type_name",
      header: () => "inquiry Type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "payouts",
      header: () => "Payout",
      cell: (info) => {
        const row = info.row.original;
        return `${row.payouts || ""} ${row.payouts_type || ""}`;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchAllData();
  }, []);
  return (
    <>
      <Table data={roleData} columns={columns} />
    </>
  );
};

export default LeadPaymentTable;
